"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
import type { ApiDropVoter } from "@/generated/models/ApiDropVoter";
import type { ApiDropVotersPage } from "@/generated/models/ApiDropVotersPage";
import { commonApiFetch } from "@/services/api/common-api";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";
const DROP_VOTERS_PAGE_SIZE = 20;
const DROP_VOTERS_SORT_DIRECTION = "DESC";
interface UseDropVotersProps {
  readonly dropId: string;
  readonly enabled?: boolean | undefined;
}
const getNormalizedDropId = (dropId: string): string => dropId.trim();
const getDropVotesEndpoint = (dropId: string): string => `v2/drops/${encodeURIComponent(dropId)}/votes`;
export function useDropVoters(t0) {
  const $ = _c(22);
  const {
    dropId,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== dropId) {
    t2 = getNormalizedDropId(dropId);
    $[0] = dropId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const normalizedDropId = t2;
  const canFetch = enabled && normalizedDropId.length > 0;
  let t3;
  if ($[2] !== normalizedDropId) {
    t3 = [QueryKey.DROP_VOTERS, {
      dropId: normalizedDropId,
      pageSize: DROP_VOTERS_PAGE_SIZE,
      sortDirection: DROP_VOTERS_SORT_DIRECTION
    }];
    $[2] = normalizedDropId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const queryKey = t3;
  let t4;
  if ($[4] !== normalizedDropId) {
    t4 = async t5 => {
      const {
        pageParam
      } = t5;
      return await commonApiFetch({
        endpoint: getDropVotesEndpoint(normalizedDropId),
        params: {
          page_size: DROP_VOTERS_PAGE_SIZE.toString(),
          page: pageParam.toString(),
          sort_direction: DROP_VOTERS_SORT_DIRECTION
        }
      });
    };
    $[4] = normalizedDropId;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = getDefaultQueryRetry();
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== canFetch || $[8] !== queryKey || $[9] !== t4) {
    t6 = {
      queryKey,
      queryFn: t4,
      initialPageParam: 1,
      getNextPageParam: _temp,
      placeholderData: keepPreviousData,
      enabled: canFetch,
      staleTime: 60000,
      ...t5
    };
    $[7] = canFetch;
    $[8] = queryKey;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const query = useInfiniteQuery(t6);
  let t7;
  if ($[11] !== query.data?.pages) {
    t7 = query.data?.pages.flatMap(_temp2) ?? [];
    $[11] = query.data?.pages;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const voters = t7;
  let t8;
  if ($[13] !== query.error || $[14] !== query.fetchNextPage || $[15] !== query.hasNextPage || $[16] !== query.isError || $[17] !== query.isFetchingNextPage || $[18] !== query.isLoading || $[19] !== query.refetch || $[20] !== voters) {
    t8 = {
      voters,
      fetchNextPage: query.fetchNextPage,
      hasNextPage: query.hasNextPage,
      isLoading: query.isLoading,
      isFetchingNextPage: query.isFetchingNextPage,
      isError: query.isError,
      error: query.error,
      refetch: query.refetch
    };
    $[13] = query.error;
    $[14] = query.fetchNextPage;
    $[15] = query.hasNextPage;
    $[16] = query.isError;
    $[17] = query.isFetchingNextPage;
    $[18] = query.isLoading;
    $[19] = query.refetch;
    $[20] = voters;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}
function _temp2(page) {
  return page.data;
}
function _temp(lastPage, allPages) {
  if (!lastPage.next) {
    return null;
  }
  return typeof lastPage.page === "number" ? lastPage.page + 1 : allPages.length + 1;
}